export function formatDurationMs(durationMs: number): string {
    if (durationMs >= 3600000) {
        const hours = durationMs / 3600000;
        if (durationMs % 3600000 !== 0) {
            return `${hours.toFixed(1)} hr.`;
        }
        return `${hours.toFixed(0)} hr.`;
    }
    if (durationMs >= 60000) {
        const minutes = durationMs / 60000;
        if (durationMs % 60000 !== 0) {
            return `${minutes.toFixed(1)} min.`;
        }
        return `${minutes.toFixed(0)} min.`;
    }

    return `${(durationMs / 1000).toFixed(0)} sec.`;
}
